import { ChevronDownIcon, RadioButtonGroup } from '@selina-finance/ui';
import { SelectBoxItem } from '@selina-finance/ui/build/components/SelectBox';
import { SelectItem } from '@selina-finance/ui/build/shared/interfaces/SelectItem';

import SelectBox from '@Components/SelectBox/SelectBox';
import { radioButtonOptions } from '@Shared/helpers/input';

export interface QuestionControllerProps {
    className?: string;
    name: string;
    label: string;
    value: any;
    infoNote?: any;
    getError: (name: string) => any;
    customRadioButtonOptions?: SelectItem[];
    isRadio?: boolean;
    items?: SelectBoxItem[];
    onBlur?: (e: any) => void;
    onChange: (e: any) => void;
}

export const QuestionController = ({
    className,
    name,
    label,
    value,
    infoNote,
    getError,
    onChange,
    customRadioButtonOptions,
    isRadio,
    onBlur,
    items,
}: QuestionControllerProps) => (
    <>
        <div className='text-lg font-sora-bold leading-120% mb-2'>{label}</div>
        {infoNote}
        {isRadio ? (
            <RadioButtonGroup
                name={name}
                id={name}
                className={className}
                value={value}
                error={{
                    hasError: false,
                    errorMessage: getError(name),
                }}
                onChange={onChange}
                options={
                    customRadioButtonOptions
                        ? customRadioButtonOptions
                        : radioButtonOptions
                }
            />
        ) : (
            <SelectBox
                items={items}
                suffix={<ChevronDownIcon />}
                name={name}
                validState={!!value}
                error={getError(name)}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
            />
        )}
    </>
);
